<template>
  <div>
    <!-- <div class="block_nav" v-show="isIos"></div> -->
    <div class="discovery_navtitle">
      <img src="../../../assets/image/back.png" alt="" class="left" v-show="isShowLeft" @click="goBack">
      <!-- <van-icon name="arrow-left" size="22px" class="left" v-show="isShowLeft" @click="goBack" /> -->
      <div class="center">
        <p>{{title}}</p>
      </div>
       <img src="../../../assets/image/creams.png" alt="" v-show="isShowRight"  class="right"  @click="nativePublishFun">
      <!-- <van-icon
        name="photograph"
        size="22px"
        v-show="isShowRight"
        color="#333"
       
       
      /> -->
    </div>
  </div>
</template>
<script>
import utils from "@/utils/common";
export default {
  data() {
    return {
      isIos:false
    };
  },
  props: {
    title: {
      default: "",
      type: String
    },
    isShowLeft: {
      default: true,
      type: Boolean
    },
    isShowRight: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    nativePublishFun() {
      utils.beesPublishDiscovery();
    },
    goBack() {
      if (window.tools.isWechat()) {
        this.$router.go(-1);
      } else {
        utils.goBack();
      }
    }
  },
  created(){
    if(window.tools.isIos()){
      this.isIos=true;
    }
  }
};
</script>
<style lang="less" scoped>

.discovery_navtitle {
  height: 80px;
  background-color: #fff;
  display: flex;
  align-items: center;
  position: relative;
  .left {
    width: 44px;
    height: 44px;
    left: 20px;
    box-sizing: border-box;
    position: absolute;
  }
  .center {
    text-align: center;
    box-sizing: border-box;
    font-size: 32px;
    color: #333;
    width: 100%;
  }
  .right {
    width: 66px;
    height: 66px;
    text-align: right;
    position: absolute;
    right: 20px;
  }
}
.block_nav{
  height: 60px;
  background:#fff;
}
</style>